export default "__VITE_ASSET__DBA54USM__"